import template   from './footer.html'
import controller from './footer.controller'
import './footer.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/footer/footer.component.js